<div class="cta-background">
    <div class="cta-wrapper">
        <app-home-search-cta-banner-input></app-home-search-cta-banner-input>
        <app-responsive-container [cards]="cards" [useDesktopCarousel]="true" [cardTemplate]="cardTemplate">
        </app-responsive-container>
    </div>
</div>

<ng-template #cardTemplate let-card="$context">
    <app-home-search-cta-banner-card [props]="card.props"></app-home-search-cta-banner-card>
</ng-template>
<ng-template #ctaCard let-card="$context"> </ng-template>
